module.exports = __webpack_public_path__ + "img/Capy_sample.4d232365.png";